import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants.ts';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { BODY_SHAPE_OPTIONS } from '@/pages/Onboarding/options/BodyShape/BODY_SHAPE_OPTIONS.ts';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage.ts';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { ScreenFindAiImageStyles, ScreenFindAiStyles } from './FindAi.styles';

export const ScreenFindAi: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'FindAi',
      });
    }
  }, []);

  React.useEffect(() => {
    BODY_SHAPE_OPTIONS.forEach((option) => {
      if (webCampaign.getLayoutNotes().includes('body-shape-sports')) {
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai/body_shape_sports/${option.id}.png`,
        );
      }
    });
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const ethnicity = form.watch('ethnicity');
  const age = form.watch('age');

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  const getImageSrc = (count: number) => {
    if (webCampaign.getLayoutNotes().includes('three-screens-new')) {
      return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/three-screens-new/by_choice/${age}-${ethnicity}-${count}.png`;
    }

    return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/ethnicity/${ethnicity}/${age}-${count}.png`;
  };

  return (
    <ScreenFindAiStyles>
      <IonContent>
        <div className="images-container">
          <ScreenFindAiImageStyles>
            <img src={getImageSrc(1)} alt="greet" />
          </ScreenFindAiImageStyles>

          <ScreenFindAiImageStyles>
            <img src={getImageSrc(2)} alt="greet" />
          </ScreenFindAiImageStyles>
          <ScreenFindAiImageStyles>
            <img src={getImageSrc(3)} alt="greet" />
          </ScreenFindAiImageStyles>
          <ScreenFindAiImageStyles>
            <img src={getImageSrc(4)} alt="greet" />
          </ScreenFindAiImageStyles>
        </div>
        <OwnAiTitle className="local-title">
          Let’s find somebody who is
          <br /> perfect for you!
        </OwnAiTitle>
        <OnboardingSubtitle>
          We have a lot of AI’s that met many different preferences for each
          user
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenFindAiStyles>
  );
};
